import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppContainer from './AppContainer';
import { RELEASE_PROP_TYPES } from '../../shared/experiments/phasedRelease/config';
import HomepageComponent from '../homepage/HomepageComponent';
import homepageMetaData from '../homepage/model/metaData';
import trackingAdapter from '../homepage/tracking/trackingAdapter';
import headerProps from '../homepage/constants/headerConfig';
import {
  parseUrlChannel,
  channelObjects,
} from '../../shared/model/constants/channels';
import homepageUrlGenerator from '../../shared/model/transformers/homepageUrlGenerator';
import {
  USER_AGENT_PROP_TYPES,
  RECENT_SEARCH_PROP_TYPES,
} from '../homepage/model/types';

const { ForSale } = channelObjects;

export default class HomepageApp extends Component {
  static propTypes = {
    params: PropTypes.shape({
      userAgent: USER_AGENT_PROP_TYPES.isRequired,
      hostname: PropTypes.string,
      channel: PropTypes.string,
      error: PropTypes.object,
      isSignedIn: PropTypes.bool.isRequired,
      token: PropTypes.string,
      releases: RELEASE_PROP_TYPES.isRequired,
      recentSearches: RECENT_SEARCH_PROP_TYPES,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      query: PropTypes.shape({
        channel: PropTypes.string,
      }).isRequired,
      search: PropTypes.string,
    }).isRequired,
  }

  componentDidMount() {
    const { channel } = this.props.params;

    this.handlePageTracking(channel);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { channel } = this.props.params;
    const channelChanged = channel !== nextProps.params.channel;
    if (channelChanged) this.handlePageTracking(nextProps.params.channel);
  }

  handlePageTracking = (channel = ForSale.url) => {
    const currentChannel = parseUrlChannel(channel);

    trackingAdapter.trackPageEvent({ channelObject: currentChannel });
    window.RCA = window.RCA || {};
  }

  populateMataData = () => {
    const {
      params: {
        hostname,
      },
      location: {
        pathname,
        query,
      },
    } = this.props;
    return homepageMetaData(
      {},
      pathname,
      hostname,
      query,
    );
  }

  static metaData = homepageMetaData

  render() {
    const {
      params: {
        userAgent,
        channel = ForSale.url,
        error,
        isSignedIn,
        token,
        recentSearches,
        releases,
      },
      location: { query },
    } = this.props;
    const currentChannel = query.channel || channel;
    const currentChannelObject = parseUrlChannel(currentChannel);
    const url = homepageUrlGenerator(currentChannelObject);
    return (
      <AppContainer
        channel={channel}
        error={error}
        metaData={this.populateMataData}
        isSignedIn={isSignedIn}
        token={token}
        headerProps={headerProps(url)}
        userAgent={userAgent}
        releases={releases}
      >
        <HomepageComponent
          currentChannel={currentChannelObject}
          recentSearches={recentSearches}
        />
      </AppContainer>
    );
  }
}
